import { HttpErrorResponse } from '@angular/common/http';

import { TimeoutError } from 'rxjs';

import { GraphQLErrorCollection } from '../../shared/services/graphql.service';

/** Maps search failures to actionable copy without exposing server details. */
export function similarParagraphSearchErrorMessage(error: unknown): string {
  const timedOut =
    error instanceof TimeoutError ||
    (error instanceof HttpErrorResponse && [408, 504].includes(error.status)) ||
    (error instanceof GraphQLErrorCollection && error.errors.some((e) => e.extensions?.code === 'SIMILAR_PARAGRAPH_SEARCH_TIMEOUT'));

  return timedOut
    ? 'The similar-paragraph search took too long. Try again or choose a smaller portfolio.'
    : 'Similar paragraphs could not be loaded. Please try again.';
}
